<div
  class="ioh-trains-wrapper ioh-table-container ioh-text-styles"
  [style.left.px]="left"
  [style.top.px]="top"
  [style.z-index]="iohZIndex"
  *ngIf="
    (!terminalFlag && trains.length > 0) ||
    (terminalFlag && _terminalTrains.length > 0)
  "
  [ngStyle]="{
    fontSize: iohDynamicFontSize
  }"
>
  <div
    class="ioh-trains-list-container"
    [ngStyle]="{
      'border-color': showClose || iohShowCollapse ? '#fff' : 'transparent'
    }"
  >
    <div
      *ngIf="!showClose"
      class="ioh-arrow-background"
      [ngClass]="
        !iohShowCollapse
          ? tableArrowDirectionClass[arrowDirection - 1]
          : tableArrowDirectionClass[arrowDirection - 1] +
            ' ioh-active-arrow-background'
      "
    ></div>

    <div *ngIf="showClose" class="ioh-arrow-background top-center"></div>
    <ng-container *ngIf="!terminalFlag">
      <ng-container
        *ngFor="let train of trains | slice : 0 : iohVisibleTrainCount"
      >
        <div
          class="ioh-train-info"
          [id]="train?.trainId?.toLowerCase() + 'L' + level"
          [ngClass]="(train.trainStopped && train.stoppedTimeInMinutes && train.stoppedTimeInMinutes > 120) ? 'ioh-train-stopped' : ''"
          (click)="iohShowTrainCallout(train)"
        >
          <div
            *ngIf="
              train.lorCrewHosInd === 'C' ||
              (train.lorCrewHosInd === 'D' &&
                train.crewOnDutyTime &&
                train.crewTime &&
                !this.iohCheckSameDate(train.crewOnDutyTime, train.crewTime))
            "
            class="ioh-train-stopped-container crew-lor-crew-called"
          >
            <span></span>
          </div>
          <div
            *ngIf="train.lorCrewHosInd === 'R'"
            class="ioh-train-stopped-container crew-lor-crew-requested"
          >
            <span></span>
          </div>
          <div  *ngIf="train.lorCrewHosInd === 'NC'" class="ioh-train-stopped-container crew-lor-crew-not-called">
            <span></span>
          </div>
          <div  *ngIf="train.lorCrewHosInd === 'NR'" class="ioh-train-stopped-container crew-lor-crew-not-requested">
            <span></span>
          </div>
          <div
            class="ioh-train-prefix"
            [ngStyle]="{
              fontSize: iohDynamicFontSize
            }"
          >
            {{ train?.trainId[0] }}
          </div>
          <div
            class="ioh-train-id"
            [ngStyle]="{
              color:
                trainPerformanceClassificationColor[
                  train?.performanceClassification
                ],
              fontSize: iohDynamicFontSize
            }"
          >
            {{ train?.trainId.substring(1, 4) }}
          </div>
          <div
            class="ioh-train-trailing"
            [ngStyle]="{ fontSize: iohDynamicFontSize }"
          >
            {{ train?.trainId.substring(4) }}
          </div>
          <div class="train-length-container">
            <div *ngFor="
                      let count of iohTrainLengthByCount[
                        trainLengthClassification[train?.reportedLengthClassification]
                      ];
                      let index = index;
                      trackBy: index
                    " class="length-stick" [ngStyle]="{ 'background-color': trainLengthClassificationColors[index] }"></div>
      </div>
        </div>
      </ng-container>
    </ng-container>

    <div
      *ngIf="!showClose && !iohShowCollapse && trains.length > showCount + 1"
      (click)="iohMoreClicked(tableData)"
      class="ioh-more-button"
    >
      <div class="ioh-more-text">+{{ trains.length - showCount }} More</div>
    </div>
    <div
      *ngIf="!iohTrainIdForSearch && (iohShowCollapse || showClose)"
      class="ioh-more-button"
      (click)="iohShowCollapse ? iohCollapseClicked() : iohCloseClicked()"
    >
      <div class="ioh-more-text">
        {{ iohShowCollapse ? 'Collapse' : 'Close' }}
      </div>
    </div>
  </div>
</div>
